import { french } from '~domain/i18n/french';
import { TranslationKeys } from '~frontend-common/i18n/english/policies.i18n';

const keys: TranslationKeys = {
  policies: {
    productName: {
      car: 'Auto',
      home: {
        homeowner: 'Habitation | Propriétaire',
        condo: 'Habitation | Condo',
        tenant: 'Habitation | Locataire',
      },
    },
    policyCard: {
      effectiveDate: 'Date effective',
      expiryDate: "Date d'expiration",
      policyNumber: 'Numéro de police',
      insurer: 'Assureur',
      buttonModifyPolicy: 'Modifier police',
      buttonDocuments: 'Documents',
      tag: {
        cancelled: 'Annulée',
        expired: 'Expirée',
        renewal: 'Renouvellement',
      },
    },
    attachment: {
      filename: 'YouSet Police {{0}}.{{1}}',
    },
    modification: {
      options: {
        address: {
          subtitle: 'Modifiez votre adresse de domicile sur votre police.',
          title: 'Adresse',
        },
        addReplaceRemoveCar: {
          subtitle: 'Ajoutez, remplacez ou retirez un véhicule.',
          title: 'Auto',
        },
        bankingInformation: {
          subtitle: 'Modifiez le compte bancaire pour le prélèvement automatique mensuel.',
          title: 'Informations bancaires',
        },
        cancellation: {
          subtitle: "Résiliez votre police ou informez-nous d'un non-renouvellement pour l'année prochaine.",
          title: 'Résiliation ou non-renouvellement',
        },
        claims: {
          subtitle: 'Faire une réclamation.',
          title: 'Réclamations',
        },
        coInsured: {
          subtitle: 'Ajoutez ou retirez un co-assuré sur votre police d’assurance habitation.',
          title: 'Co-assuré',
        },
        contactInformation: {
          subtitle: 'Mettez à jour votre numéro de téléphone et votre adresse courriel.',
          title: 'Informations de contact',
        },
        help: {
          subtitle:
            "Écrivez-nous un message si la modification que vous avez besoin d'apporter n’est pas parmi les options.",
          title: "Besoin d'aide?",
        },
        occasionalDrivers: {
          subtitle: 'Ajoutez ou retirez un conducteur occasionnel sur votre police automobile.',
          title: 'Conducteur occasionnel',
        },
        requestPolicyCopy: {
          subtitle: "Demandez une copie de votre police d'assurance.",
          title: 'Copie de ma police',
        },
      },
    },
    documents: {
      downloadButton: 'Télécharger',
      empty: 'Aucun document disponibles pour le moment.',
      privateLabel: "Ce document est privé, par conséquent, il n'est pas visible dans le portail utilisateur.",
      notifyUserLabel: "L'utilisateur a été ou sera notifié par e-mail.",
      notifyBrokerLabel: 'Une tâche a été ou sera créée dans Close.',
      ...french.policies.attachments,
    },
  },
};

export default keys;
